import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminRefundSettingsResponse {
  @jsonMember(Boolean)
  public readonly isCodEmailSent!: boolean;

  @jsonArrayMember(String)
  public readonly codMessageEmails!: string[];
}
